import type { Locale } from "@/lib/i18n";
import { pl, type WSearchTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const wSearchTranslations: Record<Locale, WSearchTranslations> = { pl, en, de };
export type { WSearchTranslations };
